// extracted by mini-css-extract-plugin
export default {"icon":"Asignaturas_icon__D26E4","nuevo":"Asignaturas_nuevo__6Q-Rb"};